/* eslint-disable no-underscore-dangle */

// FormKit's select rewrites non-string option values in place — `value` becomes
// "__mask_N" and the real one moves to `__original` — but only for options it has
// rendered. Code reading shared option lists must handle both forms.
export const optionValue = (option) => ("__original" in option ? option.__original : option.value);

// Values are compared as strings: a select hands back strings, the API numbers.
export const findOption = (options, value) =>
  (options || []).find((option) => String(optionValue(option)) === String(value));
